import React, { useState, useEffect } from 'react'

import { useDispatch } from 'react-redux'

import {
  sendFileMessage,
  setAudioStream,
  setRecordingAudio,
  setVoiceRecording,
} from 'app/redux/messages/messages.actions'
import { useSelector } from 'react-redux'
import AudioAnalyser from '../../AudioAnalyser'
import { useStopwatch } from 'react-timer-hook'
import { getFileData } from 'app/redux/messages/messages.adapter'
import { SendIcon, Pause, Delete, MicrophoneOutline } from 'app/components/icons'
import AudioPlayer from 'app/components/AudioPlayer'
import './voiceRecorder.scss'

const getRecordingAudio = ({ messagesData }) => messagesData.messages.recordingAudio
const getAudioStream = ({ messagesData }) => messagesData.audioStream
const getVoiceRecording = ({ messagesData }) => messagesData.messages.voiceRecording
const getLanguageInfo = ({ widgetData }) => widgetData.widgetInfo.languageInfo

const VoiceRecorder = () => {
  const recordingAudio = useSelector(getRecordingAudio)
  const audioStream = useSelector(getAudioStream)
  const voiceRecording = useSelector(getVoiceRecording)
  const languageInfo = useSelector(getLanguageInfo)

  const [mediaRecorder, setMediaRecorder] = useState()
  const [chunks, setChunks] = useState([])
  const dispatch = useDispatch()
  const { seconds, minutes, start, reset, pause } = useStopwatch({
    autoStart: true,
  })
  const [pauseAudio, setPasuseAudio] = useState(false)
  const [file, setFile] = useState(null)

  useEffect(() => {
    if (mediaRecorder) {
      mediaRecorder.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) {
          setChunks((prev) => {
            return [...prev, e.data]
          })
        }
      }
    }
  }, [mediaRecorder])

  const startRecording = async () => {
    let stream

    if (!audioStream) {
      stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      })
      dispatch(setAudioStream(stream))
    } else {
      stream = audioStream
    }

    let t = new MediaRecorder(stream)
    setMediaRecorder(() => {
      return t
    })

    setChunks([])

    dispatch(setRecordingAudio(stream))
    if (t.state !== 'recording') {
      setChunks([])
      dispatch(setVoiceRecording(true))
      start()
      t.start(10)
    }
  }

  const handleStartRecording = (e) => {
    e.preventDefault()

    const constraints = {
      audio: true,
    }

    navigator.mediaDevices.getUserMedia(constraints).then(startRecording, () => {
      alert(languageInfo.texts?.voiceAccessDenied)
    })
  }

  const stopRecording = (e) => {
    e.preventDefault()

    dispatch(setRecordingAudio(null))
    if (mediaRecorder && mediaRecorder.state !== 'inactive') {
      mediaRecorder.stop()
      saveAudio()
    }

    dispatch(setVoiceRecording(false))
    reset()
  }

  const handlePauseRecording = (e) => {
    e.preventDefault()

    if (mediaRecorder && mediaRecorder.state === 'recording') {
      mediaRecorder.pause()
      setPasuseAudio(true)
      pause()
      saveAudio(true)
    } else {
      mediaRecorder.resume()
      setPasuseAudio(false)
      start()
    }
  }

  const handleClickDiscardBtn = () => {
    // when is recording
    if ((mediaRecorder && mediaRecorder.state !== 'inactive') || voiceRecording) {
      mediaRecorder.stop()
      dispatch(setVoiceRecording(false))
      reset()
    }
    dispatch(setRecordingAudio(null))
    setFile(null)
    setPasuseAudio(false)
  }

  const saveAudio = (isPauseFile) => {
    const blob = new Blob(chunks, { type: 'audio/mpeg' })
    const file = new File([blob], `${languageInfo.texts.voice}.mpeg`, {
      lastModified: new Date().getTime(),
      type: blob.type,
    })

    if (isPauseFile) {
      const fileMessage = getFileData(file)
      const errorMessage = languageInfo.texts.invalidFileExtension
      if (fileMessage === null) alert(errorMessage)
      else setFile(fileMessage)
    } else {
      dispatch(sendFileMessage(file))
    }
  }

  return (
    <div className="voice_recorder_container_wrapper">
      {!recordingAudio && (
        <div className="voice_recorder_container" onClick={handleStartRecording}>
          <MicrophoneOutline className="voice_recorder_icon voice_recorder_outlined_icon" />
        </div>
      )}
      {recordingAudio && (
        <>
          <div onClick={stopRecording} id="send_voice_icon" className="send_voice_icon">
            <SendIcon className="send_icon" />
          </div>
          <div className="voice_analyser_container">
            {!pauseAudio && <div className="voice_analyser_timer">{`${minutes}:${seconds}`}</div>}

            <button onClick={handlePauseRecording} className="pause_voice_icon">
              {pauseAudio ? <MicrophoneOutline className="voice_recorder_icon" /> : <Pause />}
            </button>
            {pauseAudio && file ? <AudioPlayer source={file.fileData} /> : <AudioAnalyser audio={recordingAudio} />}

            <button className="delete_voice_icon" onClick={handleClickDiscardBtn}>
              <Delete color="#C91616" />
            </button>
          </div>
        </>
      )}
    </div>
  )
}

export default React.memo(VoiceRecorder)
